export default __webpack_public_path__ + "static/media/monthly_report_guide_en@2x.e9f5218c.png";